import { gatewaySectorWorkFlows } from "../../../../../../../../gateways/gatewaySectorWorkFlows";

export interface SpecialRequestItem {
  uid: string;
  name: string;
  description: string;
  createdAt: string;
  updatedAt: string;
}

export interface PaginatedResponse<T> {
  page: number;
  pageSize: number;
  totalItems: number;
  totalPages: number;
  items: T[];
}

export type FetchSpecialRequestsFilters = {
  category?: string | null;
};

export const fetchSpecialRequests = async (
  page: number,
  pageSize = 10,
  filters?: FetchSpecialRequestsFilters
): Promise<PaginatedResponse<SpecialRequestItem>> => {
  const params = new URLSearchParams();
  params.set("page", String(page));
  params.set("pageSize", String(pageSize));
  const category = filters?.category?.trim();
  if (category) {
    params.set("category", category);
  }

  const response = await gatewaySectorWorkFlows.get<PaginatedResponse<SpecialRequestItem>>(
    `/special-requests?${params.toString()}`
  );

  return response.data;
};
